import { render, staticRenderFns } from "./stationReferrerConfig.vue?vue&type=template&id=13bd7c2c&scoped=true"
import script from "./stationReferrerConfig.vue?vue&type=script&lang=js"
export * from "./stationReferrerConfig.vue?vue&type=script&lang=js"
import style0 from "./stationReferrerConfig.vue?vue&type=style&index=0&id=13bd7c2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bd7c2c",
  null
  
)

export default component.exports